import { Link } from "wouter";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <span className="text-xl font-bold tracking-tight text-primary">Interclub Poker Circuit</span>
            <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
              The premier pub-poker league across Australia. Premium tournaments, well-built structures, real stakes. Built for the regulars.
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider">Circuit</h3>
            <ul className="mt-4 space-y-2">
              <li><Link href="/tournaments" className="text-sm text-muted-foreground hover:text-primary transition-colors">Tournaments</Link></li>
              <li><Link href="/venues" className="text-sm text-muted-foreground hover:text-primary transition-colors">Venues</Link></li>
              <li><Link href="/leaderboard" className="text-sm text-muted-foreground hover:text-primary transition-colors">Leaderboards</Link></li>
              <li><Link href="/results" className="text-sm text-muted-foreground hover:text-primary transition-colors">Recent Results</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider">Players</h3>
            <ul className="mt-4 space-y-2">
              <li><Link href="/login" className="text-sm text-muted-foreground hover:text-primary transition-colors">Sign In</Link></li>
              <li><Link href="/signup" className="text-sm text-muted-foreground hover:text-primary transition-colors">Join the Circuit</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Interclub Poker Circuit. All rights reserved.
          </p>
          <a href="/admin/" className="text-xs text-muted-foreground hover:text-primary transition-colors">
            Staff Login
          </a>
        </div>
      </div>
    </footer>
  );
}
